// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import axios from 'axios'
import router from './router'
import store from './store'
import Antd from 'ant-design-vue';
import '@/permission'
import 'ant-design-vue/dist/antd.css';
// bpmn 工作流绘图工具的样式
import "bpmn-js/dist/assets/diagram-js.css" // 左边工具栏以及编辑节点的样式
import "bpmn-js/dist/assets/bpmn-font/css/bpmn.css"
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-codes.css"
import "bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css"

/*右边工具栏样式*/
import 'bpmn-js-properties-panel/dist/assets/bpmn-js-properties-panel.css';

// 引入百度富文本打包配置
import bdPackConfig from '@/utils/bdPackConfig'

// 引入样式
import '@/assets/css/app.css'
// 引入组件
import blank from '@/components/blank.vue'
import appfloor from '@/components/appfloor.vue'
import PageHead from '@/components/PageHead.vue'
import bottomSuspension from '@/components/bottomSuspension.vue'
import prompts from '@/components/prompts/index.vue'
import print from '@/components/print/index.vue'
import { filterPhone, isEmpty } from '@/utils/utils'
import { printFormatDate } from '@/assets/js/auth'

// 注册全局组件
Vue.component('blank', blank)
Vue.component('appfloor', appfloor)
Vue.component('PageHead', PageHead)
Vue.component('prompts', prompts)
Vue.component('bottomSuspension', bottomSuspension)
Vue.component('print', print)

Vue.prototype.$axios = axios
Vue.prototype.filterPhone = filterPhone
Vue.prototype.isEmpty = isEmpty
Vue.prototype.$printFormatDate = printFormatDate
Vue.prototype.$bdPackConfig = bdPackConfig

import Print from 'vue-print-nb'
Vue.use(Print); //注册打印

Vue.use(Antd);

Vue.config.productionTip = false
/* eslint-disable no-new */
axios.get('/static/config.json').then(res => {
  Vue.prototype.$APPID = res.data;
  new Vue({
    el: '#app',
    router,
    store,
    components: {
      App
    },
    template: '<App/>'
  })
})



// WEBPACK FOOTER //
// ./src/main.js